import { BaseRestRepository } from '~/repositories/baseRestRepository';
import { envConfig } from '~/utils/env';
import type { RentPaymentSettings, RentPaymentSettingsCompanyPortalTypedSettingsWithOverridesDocument } from '~/swagger/settings/Api';

const SETTINGS_BASE_URL = `${envConfig.service.settings}/company-portal/settings`;
const RENT_PAYMENT_SETTINGS_URL = `${SETTINGS_BASE_URL}/rentpayment`;

export class RentPaymentSettingsRepository extends BaseRestRepository {
  public async addRentPaymentSettings(payload: RentPaymentSettings) {
    const url = `${RENT_PAYMENT_SETTINGS_URL}/company`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({ settings: payload }),
    });
    return this.getJsonResponse(response);
  }

  public async addRentPaymentSettingsByLevel(level: string, levelId: string, payload: RentPaymentSettings) {
    const url = RENT_PAYMENT_SETTINGS_URL;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({ settings: payload, targets: [{ level, levelId }] }),
    });
    return this.getJsonResponse(response);
  }

  public async getRentPaymentSettings(): Promise<RentPaymentSettings> {
    const url = `${RENT_PAYMENT_SETTINGS_URL}/company`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async getRentPaymentSettingsByLevel(level: string, levelId: string) {
    const url = `${RENT_PAYMENT_SETTINGS_URL}/${level}/${levelId}`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async getAllRentPaymentSettings(): Promise<RentPaymentSettingsCompanyPortalTypedSettingsWithOverridesDocument> {
    const url = `${RENT_PAYMENT_SETTINGS_URL}/with-overrides`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async deleteRentPaymentSettingsByLevel(level: string, levelId: string) {
    const url = `${RENT_PAYMENT_SETTINGS_URL}/${level}/${levelId}`;
    const response = await this.fetchWithAuth(url, {
      method: 'DELETE',
    });
    return this.getJsonResponse(response);
  }
}

export const rentPaymentSettingsRepository = new RentPaymentSettingsRepository();
